import Microlink from '@microlink/react';
import download from './Assets/download.png';
export function renderMessages(message, index, username) {
  if (message.type === 'text') {
    let link = message.message.match(/href="([^"]*)/);

    return (
      <div
        key={index}
        className="message"
        id={username === message.author ? 'you' : 'other'}
      >
        <div className="content-wrapper">
          <div className="message-meta">
            <p id="author">{message.author}</p>
          </div>
          <div className="message-content">
            <div
              className="text"
              dangerouslySetInnerHTML={{
                __html: message.message,
              }}
            />
          </div>

          <>
            {link ? (
              <div
                className="link-preview"
                style={
                  link[1] !== 'notalink'
                    ? { display: 'flex' }
                    : { display: 'none' }
                }
              >
                <Microlink style={{ minWidth: '100%' }} url={link[1]} />
              </div>
            ) : null}
          </>
          <div className="message-meta">
            <p id="time">{message.time}</p>
          </div>
        </div>
      </div>
    );
  } else {
    const blob = new Blob([message.message], {
      type: message.type,
    });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = message.fileName;
    return (
      <div
        key={index}
        className="message"
        id={username === message.author ? 'you' : 'other'}
      >
        <div>
          <div className="message-meta">
            <p id="author">{message.author}</p>
          </div>
          <div className="file">
            <p>{message.fileName}</p>
            <div className="download-button" onClick={() => link.click()}>
              Download
            </div>
          </div>
          <div className="message-meta">
            <p id="time">{message.time}</p>
          </div>
        </div>
      </div>
    );
  }
}
